import React from 'react';
import PublicNav from './PublicNav';
import PublicFooter from './PublicFooter';
import PublicChatWidget from './PublicChatWidget';
import '../../assets/css/public-pages.css';

export default function PublicPageShell({ children }) {
  return (
    <div className="pp-page">
      <PublicNav />
      {children}
      <PublicFooter />
      <PublicChatWidget />
    </div>
  );
}
